import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackPlanUpgradeModalClicked.meta';

export type UseTrackPlanUpgradeModalClickedParams = {
  old_plan: string;
  new_plan: string;
};

export const useTrackPlanUpgradeModalClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackPlanUpgradeModalClicked = useCallback(
    (params: UseTrackPlanUpgradeModalClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackPlanUpgradeModalClicked };
};
